import { subscribeChannel, publishChannel } from './channelUtils';

export function sendAlerts(alert) {
    
    publishChannel('trip-alert-analysis-upsert', alert);

}

export function sendAlertsBatch(alerts) {
    
    publishChannel('trip-alert-analysis-batch-upsert', alerts);

}

export function sendDeleteAlert({ date, codigo }) {
    
    publishChannel('trip-alert-analysis-delete', { date, codigo });

}

export function listenTripAlertsAnalysis(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trip-alert-analysis-upsert' &&
            tipo !== 'trip-alert-analysis-batch-upsert' &&
            tipo !== 'trip-alert-analysis-delete'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}